/**
 * The Verordnungen the Studio V2 design concept (Prototype VIII) specifies
 * condition fields for, named by the app's canonical framework slugs — the
 * keys `conditions.ts::conditionSpec` resolves.
 *
 * This list is a CONTRACT CHECK, not a runtime lookup: the unit cards call
 * `conditionSpec(statement.framework)` directly. The companion test asserts
 * every concept framework resolves to its own authored spec (never the GENERIC
 * fallback), so a CMS rename or a spec removal fails loudly here instead of
 * silently rendering a one-field generic mask in production.
 */
export const CONCEPT_FRAMEWORK_SLUGS = [
  "reach-svhc",
  "reach-annex14",
  "reach-annex17",
  "rohs",
  "pop",
  "pfas",
  "tsca",
  "cp65",
  "china-rohs",
  "halogen-free",
] as const
